/*(function ($) {
  'use strict';

  var isMobile = window.innerWidth <= 798;

  // Poll for Convert body class first
  var classPoll = setInterval(function () {
    var isV1 = $('body').hasClass('pdp-info-gallery-one');
    var isV2 = $('body').hasClass('pdp-info-gallery-two');

    if (!isV1 && !isV2) return;
    clearInterval(classPoll);

    // Then poll for gallery ready
    var galleryPoll = setInterval(function () {
      var $gallery = $('.abtest-gallery-original .js-product-gallery');
      if (!$gallery.length || !$gallery.hasClass('flickity-enabled')) return;
      clearInterval(galleryPoll);

      if (isV1) initV1($gallery);
      if (isV2 && isMobile) initV2($gallery);
    }, 300);

  }, 100); // Convert usually fires within 500ms

  // Safety: stop polling after 5s
//   setTimeout(function () {
//     clearInterval(classPoll);
//   }, 5000);

  function initV1($gallery) {
    // Disable lightbox
    $gallery.find('a.lightbox').each(function () {
      $(this).removeAttr('data-fancybox').css('pointer-events', 'none');
    });
    $gallery.find('.abicon-zoom').hide();

    // Slide counter
    var flkty    = $gallery.data('flickity');
    var total    = flkty.slides.length;
    var $wrp     = $gallery.closest('.product-gallery--wrp');

    var $counter = $('<div class="pgtest-counter">1/' + total + '</div>');
    $wrp.append($counter);

    $gallery.on('change.flickity', function (e, idx) {
      $counter.text((idx + 1) + '/' + total);
    });
  }

  function initV2($gallery) {
    $gallery.flickity('destroy');

    $gallery.flickity({
      wrapAround     : true,
      adaptiveHeight : true,
      dragThreshold  : 10,
      imagesLoaded   : true,
      pageDots       : false,
      prevNextButtons: false,
      cellAlign      : 'left',
      contain        : false,
      draggable      : true,
    });
  }

}(jQuery));
*/

(function ($) {
  'use strict';

  function isV1() {
    return document.body.classList.contains('pdp-info-gallery-one');
  }

  var classPoll = setInterval(function () {
    if (!isV1()) return;
    clearInterval(classPoll);
    waitForGallery();
  }, 100);

  // stop polling after 10s if this never becomes a V1 page
  setTimeout(function () {
    clearInterval(classPoll);
  }, 10000);

  function waitForGallery() {
    var poll = setInterval(function () {
      var $gallery = $('.abtest-gallery-original .js-product-gallery');
      if (!$gallery.length || !$gallery.hasClass('flickity-enabled')) return;
      clearInterval(poll);
      initV1($gallery);
    }, 300);
  }

  function initV1($gallery) {
    // Disable lightbox
    $gallery.find('a.lightbox').each(function () {
      $(this).removeAttr('data-fancybox').css('pointer-events', 'none');
    });
    $gallery.find('.abicon-zoom').hide();

    // Slide counter
    var flkty = $gallery.data('flickity');
    var total = flkty.slides.length;
    var $wrp  = $gallery.closest('.product-gallery--wrp');

    var $counter = $('<div class="pgtest-counter">1/' + total + '</div>');
    $wrp.append($counter);

    var $progressWrp = $('<div class="pgtest-progress-wrp"><div class="pgtest-progress-bar"></div></div>');
    $wrp.append($progressWrp);
    var $progressBar = $progressWrp.find('.pgtest-progress-bar');

    function updateProgress(idx) {
      var percent = ((idx + 1) / total) * 100;
      $progressBar.css('width', percent + '%');
    }

    updateProgress(0);

    $gallery.on('change.flickity', function (e, idx) {
      $counter.text((idx + 1) + '/' + total);
      updateProgress(idx);
    });
  }

}(jQuery));


(function ($) {
  'use strict';

  var isMobile = window.innerWidth <= 798;

  var classPoll = setInterval(function () {
    if (!$('body').hasClass('pdp-info-gallery-two')) return;
    clearInterval(classPoll);

    if (!isMobile) return;

    // Wait for browser to repaint CSS after Convert adds class
    setTimeout(function () {

      var galleryPoll = setInterval(function () {
        var $gallery = $('.abtest-gallery-original .js-product-gallery');
        if (!$gallery.length || !$gallery.hasClass('flickity-enabled')) return;
        clearInterval(galleryPoll);

        requestAnimationFrame(function () {
          initV2($gallery);
        });

      }, 300);

    }, 300); // give browser time to apply CSS from new body class

  }, 100);

  setTimeout(function () {
    clearInterval(classPoll);
  }, 5000);

  function initV2($gallery) {
    
    $gallery.flickity('option', {
        wrapAround     : true,
        adaptiveHeight : true,
        dragThreshold  : 10,
        cssWatch       : true,
        imagesLoaded   : true,
        pageDots       : false,
        prevNextButtons: false,
        cellAlign      : 'left',
        contain        : false,
        draggable      : true,
    });

        $gallery.flickity('resize');
    }

}(jQuery));
